import { render } from "./patent.vue?vue&type=template&id=c6e4d4b8&scoped=true"
import script from "./patent.vue?vue&type=script&lang=js"
export * from "./patent.vue?vue&type=script&lang=js"

import "./patent.vue?vue&type=style&index=0&id=c6e4d4b8&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6e4d4b8"]])

export default __exports__